<template>
  <div class="alchemy p-1">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      <!-- Monitoring Section-->
      <div v-if="section == 'monitoring' && sections.includes('monitoring')" style="margin-top: 92px;">
        <Monitoring :key="compkeys.monitoring"></Monitoring>
      </div>
      <!-- Devices Section-->
      <div v-if="section == 'devices' && sections.includes('devices')" style="margin-top: 92px;">
        <Devices :key="compkeys.devices"></Devices>
      </div>
      <!-- Events Section-->
      <div v-if="section == 'events' && sections.includes('events')" style="margin-top: 92px;">
        <Events :key="compkeys.events"></Events>
      </div>
      <!-- Events Section-->
      <div v-if="section == 'thresholds' && sections.includes('thresholds')" style="margin-top: 92px;">
        <Thresholds :key="compkeys.thresholds"></Thresholds>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'

import Monitoring from '@/components/apps-components/alchemy/Monitoring.vue'
import Events from '@/components/apps-components/alchemy/Events.vue'
import Devices from '@/components/apps-components/alchemy/Devices.vue'
import Thresholds from '@/components/apps-components/alchemy/Thresholds.vue'

import axios from "axios";

export default {
  name: 'Alchemy',
  components: {
    HeaderBar3,
    Monitoring,
    Devices,
    Events,
    Thresholds
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'alchemy',
      hbref: 'hb_alchemy',
      section: null,
      preferred: 'monitoring',
      sections: [],
      apps: {},

      // Component keys
      compkeys: {
        monitoring: 0,
        devices: 0,
        events: 0,
        thresholds: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

<style scoped>
  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }
</style>
